import { Component, Input } from '@angular/core';
import { TableComponent } from '../../../../core/table/table.component';
import { ColumnComponent } from '../../../../core/table/column.component';
import { TabComponent } from '../../../../core/panels/tab-panel/tab.component';
import { TabPanelComponent } from '../../../../core/panels/tab-panel/tab-panel.component';
import { CoverageDetailComponent } from './coverages-detail.component';
import { PolicyAttributesComponent } from '../../../policy-details/policy-attributes.component';
import { CoverageDeductibleComponent } from './coverages-deductible.component';
import { CoverageLimitComponent } from './coverages-limit.component';

@Component({
  selector: 'app-coverages',
  imports: [
    TableComponent,
    ColumnComponent,
    TabComponent,
    TabPanelComponent,
    CoverageDetailComponent,
    PolicyAttributesComponent,
    CoverageDeductibleComponent,
    CoverageLimitComponent,
  ],
  template: ` <app-table
    [dataSource]="dataSource"
    [pageSize]="5"
    [scrollable]="false"
    [expandable]="true"
    dataKey="id"
    recordLabel="Coverage"
    [globalFilterFields]="[
      'details.coverageType',
      'details.aslobSubCode',
      'details.effectiveDate',
      'details.expireDate',
      'details.canceledDate',
      'details.description',
    ]"
  >
    <app-column name="details.coverageType" label="Coverage type" width="15%" />
    <app-column
      name="details.aslobSubCode"
      label="ASLOB Sub-code"
      width="15%"
    />
    <app-column
      name="details.effectiveDate"
      label="Effective date"
      width="15%"
      format="d"
    />
    <app-column
      name="details.expireDate"
      label="Expire date"
      width="15%"
      format="d"
    />
    <app-column
      name="details.canceledDate"
      label="Canceled date"
      width="15%"
      format="d"
    />
    <app-column name="details.description" label="Description" width="20%" />
    <ng-template #expand let-data>
      <div class="tw-flex tw-gap-8">
        <div class="tw-basis-full">
          <app-tab-panel>
            <app-tab label="Detail">
              <ng-template #content>
                <app-coverage-detail [dataSource]="data.details" />
              </ng-template>
            </app-tab>
            <app-tab label="Attributes" [count]="data.attributes.length">
              <ng-template #content>
                <app-policy-attributes
                  [dataSource]="data.attributes"
                  [showEmpty]="true"
                  [source]="lineOfBusiness"
                  layout="policy"
                  theme="Dark"
                />
              </ng-template>
            </app-tab>
            <app-tab label="Deductibles" [count]="data.deductibles.length">
              <ng-template #content>
                <app-coverage-deductible [dataSource]="data.deductibles" />
              </ng-template>
            </app-tab>
            <app-tab label="Limits" [count]="data.limits.length">
              <ng-template #content>
                <app-coverage-limit [dataSource]="data.limits" />
              </ng-template>
            </app-tab>
          </app-tab-panel>
        </div>
      </div>
    </ng-template>
  </app-table>`,
  styles: [],
})
export class PolicyCoveragesComponent {
  @Input() dataSource: any;
  @Input() lineOfBusiness: string;
}
